// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var SelectBoxNew$ReactHooksTemplate = require("../common/SelectBoxNew.res.js");
var SmtpSettings$ReactHooksTemplate = require("./SmtpSettings.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var NewPasswordInput$ReactHooksTemplate = require("../common/NewPasswordInput.res.js");

var initialState = {
  notification: undefined
};

function fetchSmtpConf(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/smtp_configurations", SmtpSettings$ReactHooksTemplate.decode);
}

function EmailChannel(props) {
  var match = React.useState(function (param) {
        return SmtpSettings$ReactHooksTemplate.initialConf;
      });
  var setsmtpConf = match[1];
  var smtpConf = match[0];
  var match$1 = React.useState(function (param) {
        return initialState;
      });
  var setState = match$1[1];
  React.useEffect((function (param) {
          Js_promise.then_((function (conf) {
                  return Promise.resolve(Curry._1(setsmtpConf, (function (param) {
                                    return conf;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/smtp_configurations", SmtpSettings$ReactHooksTemplate.decode));
        }), []);
  var buildSmtpConfigDict = function (form) {
    var params = {};
    params["id"] = SmtpSettings$ReactHooksTemplate.configId(form);
    params["address"] = SmtpSettings$ReactHooksTemplate.address(form);
    params["port"] = SmtpSettings$ReactHooksTemplate.port(form);
    var uName = SmtpSettings$ReactHooksTemplate.userName(form);
    params["user_name"] = uName !== undefined ? uName : "";
    params["password"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.show, SmtpSettings$ReactHooksTemplate.password(form));
    var openSsl = SmtpSettings$ReactHooksTemplate.opensslVerifyMode(form);
    params["openssl_verify_mode"] = openSsl !== undefined ? openSsl : "";
    params["enable_starttls_auto"] = Pervasives.string_of_bool(SmtpSettings$ReactHooksTemplate.enableStarttlsAuto(form));
    return params;
  };
  var handleInputAddressChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setsmtpConf, (function (smtpConf) {
            return SmtpSettings$ReactHooksTemplate.setAddress(smtpConf, value);
          }));
  };
  var handleInputPortChange = function ($$event) {
    var port = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setsmtpConf, (function (smtpConf) {
            return SmtpSettings$ReactHooksTemplate.setPort(smtpConf, port);
          }));
  };
  var handleInputUserNameChange = function ($$event) {
    var userName = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setsmtpConf, (function (smtpConf) {
            return SmtpSettings$ReactHooksTemplate.setUserName(smtpConf, userName);
          }));
  };
  var handleInputPasswordChange = function ($$event) {
    var password = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setsmtpConf, (function (smtpConf) {
            return SmtpSettings$ReactHooksTemplate.setPassWord(smtpConf, Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.create, password));
          }));
  };
  var handleInputChangeForOpenSSl = function ($$event) {
    var openSsl = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setsmtpConf, (function (smtpConf) {
            return SmtpSettings$ReactHooksTemplate.setopensslVerifyMode(smtpConf, openSsl);
          }));
  };
  var handleInputChangeForEnableStarttls = function ($$event) {
    var enalbeStart = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setsmtpConf, (function (smtpConf) {
            return SmtpSettings$ReactHooksTemplate.setenableStarttlsAuto(smtpConf, Pervasives.bool_of_string(enalbeStart));
          }));
  };
  var alertType = match$1[0].notification;
  var u = SmtpSettings$ReactHooksTemplate.userName(smtpConf);
  var u$1 = SmtpSettings$ReactHooksTemplate.opensslVerifyMode(smtpConf);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        "Email",
                        alertType !== undefined ? JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                alertType: alertType,
                                handleClose: (function (param) {
                                    Curry._1(setState, (function (param) {
                                            return {
                                                    notification: undefined
                                                  };
                                          }));
                                  })
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "px-5 py-6 border-b border-gray-300 text-darkcharcoal font-bold text-xl"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "SMTP Configuration",
                                    className: "text-base font-bold"
                                  }),
                              JsxRuntime.jsx("form", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                          label: "Address",
                                                          value: SmtpSettings$ReactHooksTemplate.address(smtpConf),
                                                          handleChange: handleInputAddressChange,
                                                          labelCSS: "text-base font-medium",
                                                          placeholder: "Type SMTP Address"
                                                        }),
                                                    SmtpSettings$ReactHooksTemplate.address(smtpConf).length === 0 ? JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx("p", {
                                                                  children: "Address can't be emtpy",
                                                                  className: "text-red-500 text-xs float-right"
                                                                }),
                                                            className: "my-2"
                                                          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                  ],
                                                  className: "w-2/3 mb-6"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                          label: "Port",
                                                          value: SmtpSettings$ReactHooksTemplate.port(smtpConf),
                                                          handleChange: handleInputPortChange,
                                                          labelCSS: "text-base font-medium",
                                                          placeholder: "Type SMTP Port"
                                                        }),
                                                    SmtpSettings$ReactHooksTemplate.port(smtpConf).length === 0 ? JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx("p", {
                                                                  children: "Port can't be emtpy",
                                                                  className: "text-red-500 text-xs float-right"
                                                                }),
                                                            className: "my-2"
                                                          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                  ],
                                                  className: "w-2/3 mb-6"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                        label: "User Name",
                                                        value: u !== undefined ? u : "",
                                                        handleChange: handleInputUserNameChange,
                                                        labelCSS: "text-base font-medium",
                                                        placeholder: "Type SMTP User Name"
                                                      }),
                                                  className: "w-2/3 mb-6"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(NewPasswordInput$ReactHooksTemplate.make, {
                                                        password: SmtpSettings$ReactHooksTemplate.password(smtpConf),
                                                        label: "Password",
                                                        handleChange: handleInputPasswordChange,
                                                        passwordInputClassName: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                                        labelClassName: "text-base font-medium",
                                                        containerClassName: "flex justify-between items-center"
                                                      }),
                                                  className: "w-2/3 mb-6"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                        label: "OpenSSL Verify Mode",
                                                        value: u$1 !== undefined ? u$1 : "",
                                                        handleChange: handleInputChangeForOpenSSl,
                                                        labelCSS: "text-base font-medium",
                                                        placeholder: ""
                                                      }),
                                                  className: "w-2/3 mb-6"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(SelectBoxNew$ReactHooksTemplate.make, {
                                                        label: "Enable StarttlsAuto",
                                                        value: Pervasives.string_of_bool(SmtpSettings$ReactHooksTemplate.enableStarttlsAuto(smtpConf)),
                                                        handleChange: handleInputChangeForEnableStarttls,
                                                        labelCSS: "text-base font-medium",
                                                        options: {
                                                          hd: "true",
                                                          tl: {
                                                            hd: "false",
                                                            tl: /* [] */0
                                                          }
                                                        }
                                                      }),
                                                  className: "w-2/3 mb-6"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("a", {
                                                                children: "Cancel",
                                                                className: "bg-white ml-4 px-5 py-3 rounded border border-bg-black hover:text-pigmentblue hover:border-pigmentblue text-black font-16px",
                                                                href: "/general_settings"
                                                              }),
                                                          JsxRuntime.jsx("input", {
                                                                className: "bg-pigmentblue rounded hover:bg-cetaceanblue ml-4 px-6 py-3 font-normal text-white font-16-px leading-snug",
                                                                type: "submit",
                                                                value: "Submit"
                                                              })
                                                        ],
                                                        className: "flex justify-end"
                                                      }),
                                                  className: "w-2/3 mb-6"
                                                })
                                          ],
                                          className: "mt-8"
                                        }),
                                    onSubmit: (function (param) {
                                        param.preventDefault();
                                        var configId = SmtpSettings$ReactHooksTemplate.configId(smtpConf);
                                        Js_promise.then_((function (response) {
                                                var status = Json_decode.field("status", Json_decode.string, response);
                                                switch (status) {
                                                  case "error" :
                                                      Curry._1(setState, (function (_state) {
                                                              return {
                                                                      notification: {
                                                                        TAG: "Failure",
                                                                        _0: "Error in updating the Configuration"
                                                                      }
                                                                    };
                                                            }));
                                                      break;
                                                  case "success" :
                                                      Curry._1(setState, (function (_state) {
                                                              return {
                                                                      notification: {
                                                                        TAG: "Success",
                                                                        _0: "Updated the Configuration"
                                                                      }
                                                                    };
                                                            }));
                                                      break;
                                                  default:
                                                    Curry._1(setState, (function (_state) {
                                                            return {
                                                                    notification: {
                                                                      TAG: "Failure",
                                                                      _0: "Something went wrong. Please contact admin"
                                                                    }
                                                                  };
                                                          }));
                                                }
                                                return Promise.resolve((console.log(response), undefined));
                                              }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/smtp_configurations/" + String(configId) + "/update", buildSmtpConfigDict(smtpConf)));
                                        return Curry._1(setsmtpConf, (function (param) {
                                                      return smtpConf;
                                                    }));
                                      })
                                  })
                            ]
                          }),
                      className: "p-8 flex flex-col h-full"
                    })
              ]
            });
}

var make = EmailChannel;

exports.initialState = initialState;
exports.fetchSmtpConf = fetchSmtpConf;
exports.make = make;
/* react Not a pure module */
